<template>
  <div style="width: 427px">
    <sidebar-lists class="mb-3" />
    <sidebar-search class="mb-3 sidebar-rounded" />
    <sidebar-contact />
  </div>
</template>

<script>
import SidebarContact from '@/components/sidebar/SidebarContact';
import SidebarLists from '@/components/sidebar/SidebarLists';
import SidebarSearch from '@/components/sidebar/SidebarSearch';

export default {
  name: 'TheSidebarBody',
  components: { SidebarContact, SidebarLists, SidebarSearch },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .sidebar-rounded {
    border-radius: 8px !important;
    overflow: hidden;
  }
}
</style>
